import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHouzz = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	"aria-label": "houzz source icon",
	style: { color: "#4CAF50" },
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M10 8h18v16H46V8h8v48H46V32H28v24H10V8z"
	})
});
export default SvgHouzz;
